<template>
    <div>
        <div class="heading-search column-group">
            <div class="control-group all-40 small-100 tiny-100">
               <h1 class="heading-title">Notícias</h1>
            </div>
            <div class="all-60 small-100 tiny-100">
                <form class="ink-form">
                    <div class="control-group">
                        <div class="control append-button">
                            <span>
                                <input type="text" name="search-articles" id="search-articles" placeholder="Pesquisar artigos...">
                            </span>
                            <button class="ink-button"><i class="fas fa-search"></i>
                                <span class="hide-all">Pesquisar</span>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>


        <div class="column-group gutters double-bottom-space">
            <div class="all-100">
                <h2 class="section-title no-margin">Atualidade</h2>
            </div>
            <div class="all-33 medium-50 small-100" v-for="n in 3">
                <NewsCard></NewsCard>
            </div>
            <div class="all-33 medium-50 small-100" v-for="n in 6" v-if="!sectionView">
                <NewsCard></NewsCard>
            </div>

            <div class="ink-flex push-center"  v-if="sectionView">
                <a class="ink-button" href="#" v-on:click=" sectionView = !sectionView">Ver todos</a>
            </div>
        </div>


        <div class="column-group gutters double-bottom-space"  v-if="sectionView">
            <div class="all-100">
                <h2 class="section-title no-margin">Apresentações</h2>
            </div>

            <div class="all-33 medium-50 small-100" v-for="n in 3">
                <NewsCard></NewsCard>
            </div>

            <div class="ink-flex push-center">
                <a class="ink-button" href="#" v-on:click=" sectionView = !sectionView">Ver todos</a>
            </div>
        </div>

        <div class="column-group gutters double-bottom-space" v-if="sectionView">
            <div class="all-100">
                <h2 class="section-title no-margin">Mobilidade</h2>
            </div>

            <div class="all-33 medium-50 small-100" v-for="n in 3">
                <NewsCard></NewsCard>
            </div>

            <div class="ink-flex push-center">
                <a class="ink-button" href="#" v-on:click=" sectionView = !sectionView">Ver todos</a>
            </div>
        </div>
        <pagination class="bottom-space" v-if="!sectionView"></pagination>
    </div>
</template>

<script>
    import NewsCard from '../shared/news-card.vue'
    import Pagination from '../shared/pagination.vue'

    export default {
        components: {
            NewsCard,
            Pagination
        },
        data() {
            return {
                sectionView: true
            }
        }
    };
</script>